var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03841 5.1681L5.57565 4.09127C5.59844 4.07531 5.61354 4.05057 5.61734 4.02301C5.62114 3.99546 5.61329 3.96756 5.59567 3.94603L4.76964 2.93667C4.73649 2.89617 4.67773 2.88807 4.63487 2.9181L1.21382 5.31453C1.02368 5.44773 0.906656 5.6559 0.900274 5.88175C0.893891 6.10765 0.999063 6.32153 1.18176 6.464L4.60282 9.13173C4.64403 9.16387 4.70304 9.15886 4.73823 9.12022L5.62014 8.15217C5.6389 8.13158 5.64822 8.1041 5.64586 8.07635C5.6435 8.0486 5.62967 8.02309 5.60771 8.00597L3.8485 6.63414H11.2632C11.9712 6.63414 12.5316 7.16338 12.5316 7.80018V10.4679C12.5316 11.1047 11.9712 11.634 11.2632 11.634H4.42105C4.36582 11.634 4.32105 11.6787 4.32105 11.734V13C4.32105 13.0552 4.36582 13.1 4.42105 13.1H11.2632C12.8224 13.1 14.1 11.9288 14.1 10.4679V7.80018C14.1 6.33934 12.8224 5.1681 11.2632 5.1681H4.03841Z",
    fill: "#808080",
    stroke: "#808080",
    strokeWidth: 0.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.92360c3ff0e75fe9dbdd2faaabbbbfdb.svg";
export { ForwardRef as ReactComponent };